
import { Variables } from "../../variables";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class AnonymousLayout extends Vue {
  get fileAssets() {
    let path =
      Variables.FileAssets == "/"
        ? Variables.FileAssets
        : `${Variables.FileAssets}/`;
    return path;
  }
}
